<template>
  <div class="report-online-property-pay-container animated fadeInRight">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('reportOnlinePropertyPay.search.title') }}</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="reportOnlinePropertyPayInfo.conditions.orderId"
            :placeholder="$t('reportOnlinePropertyPay.search.orderId')" clearable />
        </el-col>

        <el-col :span="4">
          <el-input v-model="reportOnlinePropertyPayInfo.conditions.transactionId"
            :placeholder="$t('reportOnlinePropertyPay.search.transactionId')" clearable />
        </el-col>

        <el-col :span="4">
          <el-input v-model="reportOnlinePropertyPayInfo.conditions.payerObjName"
            :placeholder="$t('reportOnlinePropertyPay.search.payerObjName')" clearable />
        </el-col>

        <el-col :span="4">
          <el-input v-model="reportOnlinePropertyPayInfo.conditions.ownerName"
            :placeholder="$t('reportOnlinePropertyPay.search.ownerName')" clearable />
        </el-col>

        <el-col :span="4">
          <el-select v-model="reportOnlinePropertyPayInfo.conditions.state"
            :placeholder="$t('reportOnlinePropertyPay.search.payState')" style="width: 100%" clearable>
            <el-option v-for="(item, index) in reportOnlinePropertyPayInfo.states" :key="index" :label="item.name"
              :value="item.statusCd" />
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-button type="primary" @click="_queryMethod()">
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="_resetMethod()">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="4">
          <el-date-picker v-model="reportOnlinePropertyPayInfo.conditions.startTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('reportOnlinePropertyPay.search.startTime')"
            style="width: 100%" />
        </el-col>

        <el-col :span="4">
          <el-date-picker v-model="reportOnlinePropertyPayInfo.conditions.endTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('reportOnlinePropertyPay.search.endTime')"
            style="width: 100%" @change="validateDate" />
        </el-col>

        <el-col :span="4" v-if="reportOnlinePropertyPayInfo.communitys.length > 1">
          <el-select v-model="reportOnlinePropertyPayInfo.conditions.communityId"
            :placeholder="$t('reportOnlinePropertyPay.search.community')" style="width: 100%" clearable
            @change="_changCommunity">
            <el-option v-for="(item, index) in reportOnlinePropertyPayInfo.communitys" :key="index" :label="item.name"
              :value="item.communityId" />
          </el-select>
        </el-col>
      </el-row>
    </el-card>

    <!-- 微信物业费缴纳列表 -->
    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <div>
          <span>{{ $t('reportOnlinePropertyPay.table.title') }}</span>
          <el-tooltip effect="dark" :content="$t('reportOnlinePropertyPay.table.tooltip')" placement="top">
            <i class="el-icon-info" style="margin-left: 10px; cursor: pointer"></i>
          </el-tooltip>
        </div>
      </div>

      <el-table :data="reportOnlinePropertyPayInfo.fees" border style="width: 100%" v-loading="loading">
        <el-table-column prop="orderId" :label="$t('reportOnlinePropertyPay.table.orderId')" align="center"
          min-width="210" show-overflow-tooltip />
        <el-table-column prop="transactionId" :label="$t('reportOnlinePropertyPay.table.transactionId')"
          align="center" min-width="230" show-overflow-tooltip />
        <el-table-column prop="communityName" :label="$t('reportOnlinePropertyPay.table.community')" align="center"
          width="110" show-overflow-tooltip />
        <el-table-column :label="$t('reportOnlinePropertyPay.table.roomOwner')" align="center" width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.payerObjName || '-' }}/{{ scope.row.ownerName || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="feeNames" :label="$t('reportOnlinePropertyPay.table.feeNames')" align="center"
          width="100" show-overflow-tooltip />
        <el-table-column :label="$t('reportOnlinePropertyPay.table.feePeriod')" align="center" width="175">
          <template slot-scope="scope">
            <div v-if="scope.row.startFeeTime">
              {{ dateFormat(scope.row.startFeeTime) + '~' + dateFormat(scope.row.endFeeTime) }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('reportOnlinePropertyPay.table.payState')" align="center" width="95">
          <template slot-scope="scope">
            <el-tag :type="stateTagType(scope.row.payState)" size="small">
              {{ stateName(scope.row.payState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('reportOnlinePropertyPay.table.totalFee')" align="center" width="110">
          <template slot-scope="scope">
            <span class="amount-highlight">{{ scope.row.totalFee }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('reportOnlinePropertyPay.table.createTime')" align="center"
          width="160" />
      </el-table>

      <!-- 统计信息 -->
      <el-row class="summary-row text-left">
        <el-col :span="24">
          {{ $t('reportOnlinePropertyPay.summary.total') }}: {{ reportOnlinePropertyPayInfo.totalFeeSum }} {{
            $t('reportOnlinePropertyPay.summary.yuan') }}
        </el-col>
      </el-row>

      <!-- 说明 -->
      <el-row class="text-left table-desc">
        <el-col :span="18">
          <div>{{ $t('reportOnlinePropertyPay.explanation.defaultFilter') }}</div>
          <div>{{ $t('reportOnlinePropertyPay.explanation.orderId') }}</div>
          <div>{{ $t('reportOnlinePropertyPay.explanation.transactionId') }}</div>
          <div>{{ $t('reportOnlinePropertyPay.explanation.wState') }}</div>
        </el-col>
      </el-row>

      <!-- 分页 -->
      <el-pagination :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50, 100, 200, 500]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="reportOnlinePropertyPayInfo.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>
  </div>
</template>

<script>
import { queryOnlinePropertyPay, listMyEnteredCommunitys } from '@/api/report/reportOnlinePropertyPayApi'
import { getCommunityId } from '@/api/community/communityApi'
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'ReportOnlinePropertyPayList',
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      reportOnlinePropertyPayInfo: {
        fees: [],
        total: 0,
        records: 1,
        totalFeeSum: '0.00',
        communitys: [],
        states: [
          //全部状态：值为空串，选中即不附加 state 过滤（后端 if state != '' 跳过）
          { statusCd: '', name: this.$t('reportOnlinePropertyPay.state.ALL') },
          { statusCd: 'W', name: this.$t('reportOnlinePropertyPay.state.W') },
          { statusCd: 'C', name: this.$t('reportOnlinePropertyPay.state.C') },
          { statusCd: 'WT', name: this.$t('reportOnlinePropertyPay.state.WT') },
          { statusCd: 'CT', name: this.$t('reportOnlinePropertyPay.state.CT') },
          { statusCd: 'FT', name: this.$t('reportOnlinePropertyPay.state.FT') },
          { statusCd: 'PF', name: this.$t('reportOnlinePropertyPay.state.PF') }
        ],
        conditions: {
          orderId: '',
          transactionId: '',
          payerObjName: '',
          ownerName: '',
          //默认只展示支付成功（实收）单据；退费类（待退费/退费完成/退费失败）通过状态下拉筛选查看
          state: 'C',
          startTime: '',
          endTime: '',
          communityId: ''
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      this.reportOnlinePropertyPayInfo.conditions.communityId = getCommunityId()
      await this._loadStaffCommunitys()
      await this._listFees(1, this.pageSize)
    },

    async _listFees(page, rows) {
      this.loading = true
      try {
        const params = {
          ...this.reportOnlinePropertyPayInfo.conditions,
          page,
          row: rows
        }

        const { data, total, records, sumTotal } = await queryOnlinePropertyPay(params)

        this.reportOnlinePropertyPayInfo.fees = data || []
        this.reportOnlinePropertyPayInfo.total = total
        this.reportOnlinePropertyPayInfo.records = records
        this.reportOnlinePropertyPayInfo.totalFeeSum = sumTotal.totalFeeSum || '0.00'

        // 数据刷新后通知 layout 立即刷新待办角标（不等 60 秒轮询），已读标记后端已在查询时写入
        window.dispatchEvent(new CustomEvent('online-property-pay-changed'))
      } catch (error) {
        console.error('查询微信物业费缴纳列表失败:', error)
        this.$message.error(this.$t('reportOnlinePropertyPay.fetchError'))
      } finally {
        this.loading = false
      }
    },

    async _loadStaffCommunitys() {
      try {
        const params = {
          _uid: '123mlkdinkldldijdhuudjdjkkd',
          page: 1,
          row: 100
        }
        const { communitys } = await listMyEnteredCommunitys(params)
        this.reportOnlinePropertyPayInfo.communitys = communitys
      } catch (error) {
        console.error('获取小区列表失败:', error)
      }
    },

    _changCommunity() {
      this._listFees(1, this.pageSize)
    },

    _queryMethod() {
      this._listFees(1, this.pageSize)
    },

    _resetMethod() {
      this.reportOnlinePropertyPayInfo.conditions = {
        orderId: '',
        transactionId: '',
        payerObjName: '',
        ownerName: '',
        state: 'C',
        startTime: '',
        endTime: '',
        communityId: this.reportOnlinePropertyPayInfo.conditions.communityId
      }
      this._listFees(1, this.pageSize)
    },

    validateDate() {
      if (this.reportOnlinePropertyPayInfo.conditions.startTime &&
        this.reportOnlinePropertyPayInfo.conditions.endTime &&
        new Date(this.reportOnlinePropertyPayInfo.conditions.startTime) >=
        new Date(this.reportOnlinePropertyPayInfo.conditions.endTime)) {
        this.$message.error(this.$t('reportOnlinePropertyPay.dateError'))
        this.reportOnlinePropertyPayInfo.conditions.endTime = ''
      }
    },

    stateName(state) {
      const item = this.reportOnlinePropertyPayInfo.states.find(s => s.statusCd === state)
      return item ? item.name : (state || '-')
    },

    stateTagType(state) {
      switch (state) {
        case 'C':
          return 'success'
        case 'W':
          return 'warning'
        case 'WT':
          return 'info'
        case 'CT':
          return 'danger'
        default:
          return 'info'
      }
    },

    dateFormat,

    handleSizeChange(val) {
      this.pageSize = val
      this._listFees(this.currentPage, val)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this._listFees(val, this.pageSize)
    }
  }
}
</script>

<style lang="scss" scoped>
.report-online-property-pay-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .table-card {
    margin-bottom: 20px;
  }

  .summary-row {
    margin: 20px 0;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .amount-highlight {
    color: #f56c6c;
    font-weight: 600;
    font-size: 15px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
